import { moduleProviderFactory } from "core/providers";
import { TrackingCaseList, TrackingCaseEdit, TrackingCasePreview, TrackingCaseDocumentListView, TrackingCaseDocumentFieldValueListView, TrackingCaseDocumentFieldValueEdit } from "application/tracking-case/pages";

(function () {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: "master.app.main.tracking-case",
				pattern: "/tracking-case",
				children: [
					{
						name: "master.app.main.tracking-case.list",
						pattern: "",
						tabTitle: "TRACKING_CASE.LIST.TITLE_SECONDARY",
						component: TrackingCaseList,
						authorization: "pivotGridSection.read",
						data: {
							title: "TRACKING_CASE.LIST.TITLE_SECONDARY",
						},
					},
					{
						name: "master.app.main.tracking-case.create",
						pattern: "/create",
						tabTitle: "Create Tracking Case",
						component: TrackingCaseEdit,
						authorization: "portalSection.create",
						data: {
							back: "master.app.main.tracking-case.list",
							title: "TRACKING_CASE.EDIT.TITLE",
						},
					},
					{
						name: "master.app.main.tracking-case.edit",
						pattern: "/edit/:id",
						tabTitle: "Edit Tracking Case",
						component: TrackingCaseEdit,
						authorization: "portalSection.update",
						data: {
							back: "master.app.main.tracking-case.list",
							title: "TRACKING_CASE.EDIT.TITLE",
						},
					},
					{
						name: 'master.app.main.tracking-case.preview',
						pattern: '/preview/:id',
						tabTitle:'TRACKING_CASE.PREVIEW.TITLE',
						component: TrackingCasePreview,
						data: {
							title: 'TRACKING_CASE.PREVIEW.TITLE'
						},
					},
					{
						name: "master.app.main.tracking-case.documents",
						pattern: "/documents/:id",
						tabTitle: 'TRACKING_CASE_DOCUMENT.LIST.TITLE',
						component: TrackingCaseDocumentListView,
						authorization: "portalSection.read",
						data: {
							back: "master.app.main.tracking-case.list",
							title: "TRACKING_CASE_DOCUMENT.LIST.TITLE",
						},
					},
					{
						name: "master.app.main.tracking-case.documents.field-values",
						pattern: "/document/field-values/:id",
						tabTitle: 'TRACKING_CASE_DOCUMENT_FIELD_VALUE.LIST.TITLE',
						component: TrackingCaseDocumentFieldValueListView,
						authorization: "portalSection.read",
						data: {
							title: "TRACKING_CASE_DOCUMENT_FIELD_VALUE.LIST.TITLE",
						},
					},
					{
						name: "master.app.main.tracking-case.documents.field-values-edit",
						pattern: "/document/field-values-edit/:trackingCaseDocumentId",
						tabTitle: "TRACKING_CASE_DOCUMENT_FIELD_VALUE.LIST.TITLE",
						component: TrackingCaseDocumentFieldValueEdit,
						authorization: "portalSection.read",
						data: {
							title: "TRACKING_CASE_DOCUMENT_FIELD_VALUE.LIST.TITLE",
						}
					}
				]
			}
		],
		menu: [
			{
				title: 'MENU.FACILITY_ORDERS',
				icon: 'package',
				order: 5,
				authorization: 'coreUserSection.read',
				subMenu: [
					{
						title: 'MENU.TRACKING_CASE.TRACKING_SUB',
						authorization: "pivotGridSection.read",
						route: "master.app.main.tracking-case.list",
						order: 7,
					}
				]
			}
		]
	});
})();
